export default "__VITE_ASSET__L8d7ayyH__"